// Posted by an Ogury Creative Studio tag: the ad parser would have made it responsive had it seen it.
export const CREATIVE_OCS_MESSAGE = 'ogy:creative:ocs';
